import { IHFileUploads } from 'components/FileUploads';

export const ADD_FILE_TO_UPLOAD = 'FILES.ADD_FILE_TO_UPLOAD';
export const addFilesToUpload = (files: IHFileUploads[]) => ({
  type: ADD_FILE_TO_UPLOAD,
  payload: files
});

export const REMOVE_FILE_TO_UPLOAD = 'FILES.REMOVE_FILE_TO_UPLOAD';
export const removeFileToUpload = (uri: string) => ({
  type: REMOVE_FILE_TO_UPLOAD,
  payload: uri
});

export const CLEAR_FILE_UPLOADS = 'FILES.CLEAR_FILE_UPLOADS';
export const clearFileUploads = () => ({
  type: CLEAR_FILE_UPLOADS
});
